/**
 * 违约模态框
 * props: visible             [boolean]     是否展示模态框
 *        onOk                [function]    违约成功后的回调
 *        onCancel            [function]    取消违约
 *        goodsId             [string|number]     订单编号
 *  @arguments 撮合成交的接口在该模态框里请求，等后端出来接口之后，可能加参数props；
 */
import React, { Component } from 'react';
import { connect, Provider } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Select } from 'antd';
import { CHECK_name } from '@/shared/reqexp';
const Option = Select.Option;
const mapStateToProps = (rootState) => ({
    _state: rootState.breakContract,
});
class BreakContract extends Component {
    constructor() {
        super(...arguments);
        this.handleOk = () => {
            dispatch.breakContract.handleOk(this.props);
        };
        this.handleCancel = () => {
            dispatch.breakContract.handleCancel(this.props);
        };
    }
    render() {
        const { showBreakContract, defaultOriginator, defaultType } = this.props._state;
        const { getFieldDecorator } = this.props.form;
        return (<Modal title="发起违约" visible={showBreakContract} okText="确定" onOk={this.handleOk} cancelText="取消" onCancel={this.handleCancel}>
        <Form style={{ marginTop: '20px' }} labelCol={{ span: 5 }} wrapperCol={{ span: 12 }} labelAlign="left">
          <Form.Item label={'违约发起方'}>
            {getFieldDecorator('breakContractReason', {
            rules: [
                {
                    required: true,
                    message: '请选择违约发起方',
                },
            ],
        })(<Select getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} placeholder={'请选择'}>
                {defaultOriginator && defaultOriginator.map((item, i) => (<Option key={`item${i}`} value={item['keyName']}>{item['value']}</Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item label={'违约类型'}>
            {getFieldDecorator('breakContractType', {
            rules: [
                {
                    required: true,
                    message: '请选择违约类型',
                },
            ]
        })(<Select getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} placeholder={'请选择'}>
                {defaultType && defaultType.map((item, i) => (<Option key={`item${i}`} value={item.keyName}>{item.value}</Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item colon={false} label="备注" wrapperCol={{ span: 18 }}>
            {getFieldDecorator('remark', {
            rules: [
                { validator: CHECK_name(200) },
            ],
        })(<Input.TextArea placeholder="请输入原因（选填，100字内）" autoSize={{
            minRows: 4,
            maxRows: 5,
        }} className="delTextAreaRightDown"/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
}
const BreakContractModal = Form.create()(BreakContract);
const BreackContractTemp = connect(mapStateToProps, null, null, { forwardRef: true })(BreakContractModal);
export default BreackContractTemp;
let componentRef = '';
const createBreakContract = () => {
    const div = document.createElement('div');
    div.className = 'souche-break-contract';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(BreackContractTemp, {
        // @ts-ignore
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function ShowBreakContract({ orderId, callback }) {
    if (!componentRef) {
        createBreakContract();
    }
    dispatch.breakContract.ShowModal({ orderId, callback });
}
